var _defs, _path, _circle, _path2, _text, _text2, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreAboutYou = function SvgMoreAboutYou(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".more-about-you_svg__cls-2,.more-about-you_svg__cls-3,.more-about-you_svg__cls-4{fill:#fff}.more-about-you_svg__cls-3,.more-about-you_svg__cls-4{font-size:14px;font-family:FilsonSoftBlack,\"Filson Soft\"}.more-about-you_svg__cls-4{font-size:13px}"))), /*#__PURE__*/React.createElement("path", {
    d: "M3.2.5h32.6c1.5 0 2.7 1.2 2.7 2.7v33.4c0 1.5-1.2 2.7-2.7 2.7H3.2c-1.5 0-2.7-1.2-2.7-2.7V3.2C.5 1.7 1.7.5 3.2.5Z",
    style: {
      fill: "#2eb4b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2.5h32.6c1.5 0 2.7 1.2 2.7 2.7v33.4c0 1.5-1.2 2.7-2.7 2.7H3.2c-1.5 0-2.7-1.2-2.7-2.7V3.2C.5 1.7 1.7.5 3.2.5Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: ".82px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.45,
    cy: 19.81,
    r: 8.37,
    style: {
      fill: "#e85211"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.44 28.81a9 9 0 1 1 .001-18.001 9 9 0 0 1-.001 18.001Zm0-16.73c-4.27 0-7.73 3.46-7.73 7.73s3.46 7.73 7.73 7.73 7.73-3.46 7.73-7.73c0-4.26-3.46-7.72-7.73-7.73Z",
    className: "more-about-you_svg__cls-2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.38,
    cy: 17.81,
    r: 3.22,
    className: "more-about-you_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.43 25.34c-1.23-2.12-3.51-3.26-5.99-3.22-2.57-.04-4.94 1.28-6.05 3.58l2.59 1.68 3.47.8 3.96-1.23 2.02-1.61Z",
    className: "more-about-you_svg__cls-2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "more-about-you_svg__cls-4",
    transform: "translate(3.92 13.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "more-about-you_svg__cls-4",
    transform: "translate(28.03 35.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "more-about-you_svg__cls-3",
    transform: "translate(27.24 12.63)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "more-about-you_svg__cls-3",
    transform: "translate(3.68 35.81)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+"))));
};
export default SvgMoreAboutYou;